import MuiColor, { MuiColorsProps } from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";

interface IProps {
    variant?: "default" | "light" | "dark"
}

type Props = IProps & Omit<MuiColorsProps, "variant">;

const MuiMuted: React.FC<Props> = (props) => {
    const { children, variant, ...rest } = props;

    return (
        <MuiColor
            {...rest}
            variant={
                variant == "default"
                    ? "muted"
                    : variant == "light"
                        ? "mutedLight"
                        : "mutedDark"
            }
        >
            {children}
        </MuiColor>
    );
}

MuiMuted.defaultProps = {
    variant: "default"
}

export default MuiMuted;